// extracted by mini-css-extract-plugin
module.exports = {"root":"IconHomePin_root__MkHc4"};